<template lang="pug">
.telegram-storage
  h4.mb-1
    v-tooltip(top)
      template(#activator="{ on }")
        v-icon(v-on="on" color="warning" size="28").mr-2.pb-1 mdi-help-circle-outline
      span Позволяет хранить материалы для уроков в телеграм боте
    span Telegram хранилище
  v-alert(
    v-if="!haveTelegramStorage"
    text outlined
    type="warning"
  ).text-caption У курса еще нет хранилище в Telegram
  v-btn(
    v-else
    outlined block color="secondary"
    :href="telegram.invite_link"
  ) Перейти в хранилище
    v-icon(right) $telegram
  .grey--text Укажите id пользователей в Telegram которые будут администраторами канала
  v-combobox.mt-4(
    v-model="users"
    :items="telegramUsers"
    outlined rounded
    label="Пользователи"
    hide-details
    multiple
    small-chips
  )
    template(#no-data)
      v-list-item
        v-list-item-content
          p Вставьте id и нажмите
            kbd.ml-1 enter
            |  для добавление пользователя
    template(#append-outer)
      v-btn(
        fab
        color="secondary"
        depressed
        :disabled="!!telegram.disabled"
        @click="setTelegramStorage"
      )
        v-icon mdi-content-save-outline
  tooltip-wrap(
    :text="text"
    max-width="300"
  )
    .caption.grey--text.ml-3
      v-icon.pb-1(size="18") mdi-help-circle-outline
      |  как узнать id
</template>
<script>
export default {
  props: {
    course: { type: Object, default: () => {} },
    module: { type: Object, default: () => {} },
  },
  data() {
    return {
      text: 'Для того, чтобы указать id пользователя telegram вашего сотрудника, он должен самостоятельно запустить в телеграмм бота @GetMyIDBot и сообщить вам свой id.',
      users: null,
    };
  },
  computed: {
    type() {
      return this.module?.id ? 'module' : 'course';
    },
    telegram() {
      return this[this.type]?.telegram?.find((i) => i.type === 2) || {};
    },
    telegramUsers() {
      return [
        { header: 'Вставьте id и нажмите "Enter" для добавление пользователя' },
        ...this.telegram?.admins || [],
      ];
    },
    haveTelegramStorage() {
      return this[this.type]?.telegram?.some((i) => i.type === 2);
    },
  },
  watch: {
    telegramUsers: {
      handler(val) {
        const returnValue = [...val];
        returnValue.shift();
        this.users = returnValue;
      },
      immediate: true,
    },
  },
  methods: {

    async setTelegramStorage() {
      const { telegram, type } = this;
      const id = telegram.id || this[type]?.id;
      const admins = this.users.map((i) => +i);
      const params = { admins };
      const remethod = this.module?.id ? 'setTelegramModuleStorage' : 'setTelegramCourseStorage';
      const method = telegram.id ? 'updateTelegramChannel' : remethod;

      const { data } = await this.$api.telegram[method](id, params);

      const returnValue = telegram.id
        ? { ...data.data, admins: data.data.options.admins } : { type: 2, admins, disabled: true };

      const idx = telegram.id ? this[type].telegram.findIndex(
        (i) => i.id === telegram.id,
      ) : this.course.telegram?.length || 0;

      this.$set(this[type].telegram, `${idx}`, returnValue);
      this.$toasted.success(telegram ? 'Успешно' : 'Телеграм канал успешно создан');
    },
  },
};
</script>
